import { chipClass } from "@/components/badge/chip";
import { PR_STATE, prBadgeTone } from "@/constants/pr-state";
import { cn } from "@/lib/utils";
import type { Prd } from "@/types/domain";

// Direct GitHub links tinted by merge status (merged → primary, otherwise
// destructive; the exact state lives in the tooltip). Inbox uses plain text after the title.
// RowCard's inner-link guard keeps the click off row navigation.
export const PrLinks = ({ prd, variant = "chip" }: {
  prd: Pick<Prd, "pullRequests">;
  variant?: "chip" | "text";
}) => {
  const prs = prd.pullRequests ?? [];
  if (prs.length === 0) return null;
  return (
    <div className="flex shrink-0 items-center gap-1">
      {prs.map((pr) => (
        <a
          key={pr.url}
          href={pr.url}
          target="_blank"
          rel="noreferrer"
          title={`${pr.repo}#${pr.number} · ${(PR_STATE[pr.state] ?? PR_STATE.open).label}${pr.title ? ` · ${pr.title}` : ""}`}
          className={variant === "text"
            ? cn("hover:underline", prBadgeTone(pr.state).textClassName)
            : chipClass(prBadgeTone(pr.state).tone, "font-mono hover:underline")}
        >
          #{pr.number}
        </a>
      ))}
    </div>
  );
};
